import request from '@/utils/request';
import type {
  ConfigApolloconfigGetApolloConfigRequest,
  ConfigApolloconfigGetApolloConfigResponse,
} from '@/types/system-config/noti';

/**
 * get_apollo_config - 获取 Apollo 配置
 * https://apidoc.i.ssc.shopeemobile.com/project/33/interface/api/375090
 */
export const getApolloConfig = async (
  params: ConfigApolloconfigGetApolloConfigRequest
): Promise<ConfigApolloconfigGetApolloConfigResponse> => {
  /* PermissionKey: ALL */
  const res = await request.post(
    '/api/v2/apps/config/apolloconfig/get_apollo_config',
    params
  );
  return res;
};
